import { render, staticRenderFns } from "./MMP_SubNav.vue?vue&type=template&id=99b119e0&scoped=true&"
import script from "./MMP_SubNav.vue?vue&type=script&lang=js&"
export * from "./MMP_SubNav.vue?vue&type=script&lang=js&"
import style0 from "./MMP_SubNav.vue?vue&type=style&index=0&id=99b119e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b119e0",
  null
  
)

export default component.exports